import _sharedStore from "../internals/shared-store";
var exports = {};
var store = _sharedStore;
exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};
export default exports;